import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteHeader from "../components/gridvest/SiteHeader";
import Footer from "../components/gridvest/Footer";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#07111F] text-[#F8FAFC]" data-testid="terms-page">
      <SiteHeader />

      <main className="relative">
        <div className="gv-grid-bg absolute inset-x-0 top-0 h-[320px]" aria-hidden />

        <section className="relative mx-auto max-w-3xl px-6 pb-20 pt-16 lg:px-8 lg:pt-24">
          <Link
            to="/"
            className="mb-10 inline-flex items-center gap-2 font-body text-sm text-[#94A3B8] transition-colors hover:text-[#F8FAFC]"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to home
          </Link>

          <p className="mb-5 font-display text-[12px] font-extrabold uppercase tracking-[0.18em] text-[#38BDF8]">
            Terms of Use
          </p>
          <h1 className="font-display text-4xl font-extrabold leading-[1] tracking-[-0.04em] text-[#F8FAFC] sm:text-5xl">
            Terms of Use
          </h1>
          <p className="mt-4 font-body text-sm text-[#94A3B8]">
            Effective: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
          </p>

          <div className="mt-12 space-y-9 font-body text-[15px] leading-[1.8] text-[#CBD5E1]">
            <Sec title="1. Acceptance">
              By accessing or using the InfraYield website you agree to these Terms of
              Use. If you do not agree, do not use the website.
            </Sec>
            <Sec title="2. No Offer of Securities">
              Nothing on this website constitutes an offer to sell or a solicitation of
              an offer to buy any security. Any investment opportunities, if offered
              in the future, will be made only through compliant securities offerings
              and official offering documents to eligible investors.
            </Sec>
            <Sec title="3. Eligibility">
              The InfraYield website is intended for adults capable of forming legally
              binding agreements. Certain pages, including the Partners area, are
              restricted to authorized users only.
            </Sec>
            <Sec title="4. Acceptable Use">
              You agree not to misuse the website, including by attempting to gain
              unauthorized access, interfering with operation, scraping content
              without permission, or using the website in violation of applicable law.
            </Sec>
            <Sec title="5. Intellectual Property">
              The InfraYield name, logo, content, and design are the property of
              InfraYield and may not be reproduced, distributed, or used without prior
              written permission, except as permitted by applicable law.
            </Sec>
            <Sec title="6. Third-Party Content">
              The website may include links to third-party websites or content.
              InfraYield does not endorse and is not responsible for third-party
              websites or content.
            </Sec>
            <Sec title="7. Disclaimers">
              The website is provided on an "as is" and "as available" basis without
              warranties of any kind. InfraYield disclaims all warranties, express or
              implied, including warranties of merchantability, fitness for a
              particular purpose, and non-infringement, to the maximum extent
              permitted by law.
            </Sec>
            <Sec title="8. Limitation of Liability">
              To the maximum extent permitted by law, InfraYield will not be liable for
              any indirect, incidental, consequential, special, or punitive damages
              arising out of or related to your use of the website.
            </Sec>
            <Sec title="9. Changes">
              We may update these Terms from time to time. Material changes will be
              posted on this page with an updated effective date.
            </Sec>
            <Sec title="10. Contact">
              Questions about these Terms? Contact{" "}
              <a href="mailto:legal@infrayield.co" className="text-[#38BDF8] underline underline-offset-2 hover:text-[#F8FAFC]">legal@infrayield.co</a>.
            </Sec>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

function Sec({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-semibold uppercase tracking-[0.06em] text-[#F8FAFC]">
        {title}
      </h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}
